import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import CityService from "../../services/cityService";

export const fetchAllCities = createAsyncThunk(
  "city/fetchAllCities",
  async (params, thunkAPI) => {
    try {
      const res = await CityService.getAllCities(params);
      return res.data.data || [];
    } catch (error) {
      return thunkAPI.rejectWithValue("Fetch cities failed");
    }
  }
);

const citySlice = createSlice({
  name: "city",
  initialState: {
    cityList: [],
    selectedCity: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCities.fulfilled, (state, action) => {
        state.loading = false;
        state.cityList = action.payload;
      })
      .addCase(fetchAllCities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default citySlice.reducer;